//RESUME
export const FETCH_RESUME_SUCCESS = "fetchresume";
export const RESET_RESUME_DATA = "resetresume";
